import React from 'react';
import ReactDom from 'react-dom'
import Markdown from 'react-markdown'


interface MultiTypeDesProps {
    markdown: string;
    local_language?:string
    second_language?: string,
    third_language?:string,
}

const MultiTypeDes: React.FC<MultiTypeDesProps> = ({ markdown }) => {

    return (
        <div>
            <br />
            <Markdown>{markdown}</Markdown>
        </div>
    );
};

export default MultiTypeDes;
